const retreatShowPreferenceName = "retreat-show-preference";

export function getRetreatShowPreference(): boolean {
    return localStorage.getItem(retreatShowPreferenceName) === 'true' ? true : false;
}

export function setRetreatShowPreference(token: boolean) {
    localStorage.setItem(retreatShowPreferenceName, token ? "true" : "false");
}